// extracted by mini-css-extract-plugin
module.exports = {"header":"dashboard_header_UMQIzSt","dateInput":"dashboard_dateInput_1aKKdYm"};